"use client";

import { Checkbox } from "@kyan/ui";

// using absolute import will cause issues with the bundler
import { useShowTradeConfirmation } from "#/store/app/portfolio/settings/showTradeConfirmation";

export const TradeConfirmationCheckbox: React.FC = () => {
  const { showTradeConfirmation, setShowTradeConfirmation } =
    useShowTradeConfirmation();

  return (
    <Checkbox
      value={!showTradeConfirmation}
      label="Don’t show confirmation again"
      onValueChange={(value) => {
        setShowTradeConfirmation(!value);
      }}
    />
  );
};
